import React from 'react';
import { CaseDocumentsHome } from '../components';
import { withRouter } from 'us.common/wIthRouter';

const Cnt_CaseDocuments: React.FC= (props) => {

	return <CaseDocumentsHome {...props} />;
};

export default withRouter(Cnt_CaseDocuments);
